import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import App from "./App";
import store from "./redux/store/root";
import reportWebVitals from "./reportWebVitals";
import setupInterceptors from "./redux/api/interceptor";
import "./i18n.ts";

setupInterceptors();

ReactDOM.render(
    <React.StrictMode>
        <Provider store={store}>
            <App />
        </Provider>
    </React.StrictMode>,
    document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
if (process.env.APP_ENV !== "production") {
    reportWebVitals(console.log);
}
